import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import LoanStatusTracker from './components/LoanStatusTracker';

import Home from './pages/Home';
import Services from './pages/Services';
import Contact from './pages/Contact';
import About from './pages/About';
import FAQ from './pages/FAQ';
import CibilScore from './pages/CibilScore';
import AdminLogin from './pages/AdminLogin';
import Login from './pages/Login';
import Register from './pages/Register';
import LoanApplication from './pages/LoanApplication';
import MyApplications from './pages/MyApplications';

import EMICalculator from './components/EMICalculator';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AdminDashboard from './components/AdminDashboard';
import ProtectedRoute, { UserProtectedRoute, AdminProtectedRoute } from './components/ProtectedRoute';

import './App.css';
import './styles/enhanced-styles.css';
import './components/Footer.css';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div className="app-container">
            <Navbar />
            <main className="main-content">
              <Routes>
                {/* Public routes */}
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/about" element={<About />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/emi-calculator" element={<EMICalculator />} />
                <Route path="/cibil-score" element={<CibilScore />} />
                <Route path="/apply" element={<LoanApplication />} />
                <Route path="/track-status" element={<LoanStatusTracker />} />

                {/* User auth routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />

                {/* User protected */}
                <Route
                  path="/my-applications"
                  element={
                    <UserProtectedRoute>
                      <MyApplications />
                    </UserProtectedRoute>
                  }
                />

                {/* Admin routes */}
                <Route path="/admin" element={<AdminLogin />} />
                <Route
                  path="/admin/dashboard"
                  element={
                    <AdminProtectedRoute>
                      <AdminDashboard />
                    </AdminProtectedRoute>
                  }
                />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
